import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '💬',
    title: 'pages.quizOnboarding.desiredLevel.answer1',
    value: 'conversational',
  },
  {
    emoji: '✈️',
    title: 'pages.quizOnboarding.desiredLevel.answer2',
    value: 'travel_live',
  },
  {
    emoji: '🌟',
    title: 'pages.quizOnboarding.desiredLevel.answer3',
    value: 'think_dream',
  },
]

export default function DesiredLevelPage() {
  const language = useSelectedLanguageName()

  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.desiredLevel.title"
      translationInterpolation={{ language }}
    />
  )
}
